import { useState } from "react";
import { Container, Row, Col, Form, Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  BsTelephone,
  BsEnvelopePaper,
  BsGeoAlt,
  BsClock,
  BsChatSquare,
} from "react-icons/bs";
import { submitContact } from "../../apis/contact";
import "./contactuspage.css";

const infoCards = [
  {
    icon: <BsTelephone />,
    label: "Phone Numbers",
    lines: ["+91 97915 09915 (Main)", "+91 90927 73030"],
    link: "tel:+9197915 09915",
    linkText: "Call us anytime",
  },
  {
    icon: <BsEnvelopePaper />,
    label: "Email Address",
    lines: ["jsrdigimarketing@gmail.com", "rajakumarsurresh@jsrdigimarketing.com"],
    link: "mailto:connect@yourbrand.com",
    linkText: "Send Us An Email",
  },
  {
    icon: <BsGeoAlt />,
    label: "Office Location",
    lines: ["Royapettah, Chennai, Tamilnadu", "India – 600 014"],
    link: "#",
    linkText: "Visit Our Office",
  },
  {
    icon: <BsClock />,
    label: "Working Hours",
    lines: ["Mon - Fri : 9.00 AM - 8.00 PM", "Sat : 9.00 AM - 4.00 PM"],
    link: "#",
    linkText: "Let’s Connect",
  },
];

const faqs = [
  {
    q: "How long does a typical project take?",
    a: "Project timelines vary based on scope and complexity, typically ranging from 2–12 weeks.",
  },
  {
    q: "Do you provide ongoing support?",
    a: "Yes, we offer comprehensive support and maintenance packages for all our projects.",
  },
  {
    q: "Can you work with our existing brand?",
    a: "Absolutely! We can work within your existing brand guidelines or help refresh your brand identity.",
  },
];

export const Contactuspage = () => {
  const [focused, setFocused] = useState("");
  const [form, setForm]       = useState({ name: '', email: '', phone: '', service: '', message: '' });
  const [status, setStatus]   = useState(null);

  const fp = (name) => ({
    onFocus: () => setFocused(name),
    onBlur: () => setFocused(""),
  });

  const handle = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await submitContact(form);
      if (res.success) {
        setStatus('success');
        setForm({ name: '', email: '', phone: '', service: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <>
      {/* ── Hero ── */}
      <section className="cp-hero">
        <div className="cp-hero-orb" />
        <Container className="position-relative z-1 text-center">
          <div className="hero-badge-wrap mb-4">
            <span className="hero-badge">
              {/* <Badge className="badge-new">Grow</Badge> */}
               Grow Your Business With Us
            </span>
          </div>
          <h1 className="cp-hero-title">Let’s Talk About Your Next Move</h1>
          <p className="cp-hero-sub">
            Ready to generate more leads and scale your business? Connect with us for a strategic consultation tailored to your goals.
          </p>
          <div className="hero-actions mt-4">
            <Link to="/about" className="btn-get-in-touch-hero">
              About us <span className="arrow-icon">↗</span>
            </Link>
            <Link to="/services" className="btn-view-services">View services</Link>
          </div>
        </Container>
      </section>

      {/* ── Info Cards ── */}
      <section className="cp-info-section">
        <Container>
          <Row className="g-4">
            {infoCards.map((c, i) => (
              <Col key={i} xs={12} sm={6} lg={3}>
                <div className="cp-info-card">
                  <div className="cp-info-icon">{c.icon}</div>
                  <p className="cp-info-label">{c.label}</p>
                  {c.lines.map((l, j) => (
                    <p key={j} className="cp-info-value">
                      {l}
                    </p>
                  ))}
                  <a href={c.link} className="cp-info-link">
                    {c.linkText}
                  </a>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* ── Form + Sidebar ── */}
      <section className="cp-form-section">
        <Container>
          <Row className="g-5 align-items-start justify-content-center">
            {/* Form */}
            <Col xs={12} lg={7} className="">
              <h2 className="cp-form-title">Send Us a Message</h2>
              <p className="cp-form-sub">
                Fill out the form below and we'll get back to you within 24
                hours.
              </p>
              <Form onSubmit={handleSubmit}>
                <Row className="g-3">
                  <Col xs={12} md={6}>
                    <Form.Label className="cp-label">Full Name *</Form.Label>
                    <div className={`cp-field ${focused === "name" ? "active" : ""}`}>
                      <Form.Control
                        type="text" name="name" value={form.name}
                        placeholder="Your full name" className="cp-input"
                        onChange={handle} {...fp("name")} required
                      />
                      <span className="cp-line" />
                    </div>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="cp-label">Email Address *</Form.Label>
                    <div className={`cp-field ${focused === "email" ? "active" : ""}`}>
                      <Form.Control
                        type="email" name="email" value={form.email}
                        placeholder="your@email.com" className="cp-input"
                        onChange={handle} {...fp("email")} required
                      />
                      <span className="cp-line" />
                    </div>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="cp-label">Phone Number</Form.Label>
                    <div className={`cp-field ${focused === "phone" ? "active" : ""}`}>
                      <Form.Control
                        type="tel" name="phone" value={form.phone}
                        placeholder="+91 12345 67890" className="cp-input"
                        onChange={handle} {...fp("phone")}
                      />
                      <span className="cp-line" />
                    </div>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="cp-label">Service Interested In</Form.Label>
                    <div className={`cp-field ${focused === "service" ? "active" : ""}`}>
                      <Form.Select
                        name="service" value={form.service}
                        className="cp-input cp-select"
                        onChange={handle} {...fp("service")}
                      >
                        <option value="">Select a service</option>
                        <option>Digital Marketing & Branding</option>
                        <option>Social Media Marketing</option>
                        <option>Google Ads (PPC Campaigns)</option>
                        <option>Website Design & Development</option>
                        <option>Content Writing & Marketing</option>
                        <option>Graphic Designing & Video Editing</option>
                        <option>Online Personal Branding</option>
                        <option>Photography & Videography</option>
                        <option>Print Media & Merchandise</option>
                      </Form.Select>
                      <span className="cp-line" />
                    </div>
                  </Col>
                  <Col xs={12}>
                    <Form.Label className="cp-label">Message *</Form.Label>
                    <div className={`cp-field ${focused === "msg" ? "active" : ""}`}>
                      <Form.Control
                        as="textarea" rows={5} name="message" value={form.message}
                        placeholder="Tell us about your project..." className="cp-input"
                        onChange={handle} {...fp("msg")} required
                      />
                      <span className="cp-line" />
                    </div>
                  </Col>
                  <Col xs={12}>
                    {status === 'success' && (
                      <p style={{ color: '#96ff00', marginBottom: '12px', fontSize: '0.9rem' }}>
                        ✓ Message sent! We'll get back to you within 24 hours.
                      </p>
                    )}
                    {status === 'error' && (
                      <p style={{ color: '#ff4d4d', marginBottom: '12px', fontSize: '0.9rem' }}>
                        Something went wrong. Please try again.
                      </p>
                    )}
                    <button type="submit" className="cp-submit" disabled={status === 'sending'}>
                      {status === 'sending' ? 'Sending...' : 'Send Message'} <span className="cp-send-icon">✈</span>
                    </button>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
